import React, { useState } from 'react';
import {
  Button,
  TextField,
  CircularProgress,
  Typography,
  Modal,
  Backdrop,
  Fade,
  Box,
} from '@mui/material';
// import Logo from "../../assets/logo.png";
import useStyles from '../../../globalStyles';
import AuthBackground from '../../../components/authBackground';
import { useNavigate } from 'react-router-dom';
import './style.css';
// import { send_code } from "../../../apis";
import axios from 'axios';
import SnackbarAlert from '../../../components/snackbar/SnackbarAlert';

const PrivacyPolicy = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: '',
    message: '',
  });
  const [inputValues, setInputValues] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = () => {
    if (inputValues.name == '') {
      handleSnackbarVal(true, 'error', `Name is required`);
    } else if (inputValues.email == '') {
      handleSnackbarVal(true, 'error', `Email is required`);
    } else if (inputValues.message == '') {
      handleSnackbarVal(true, 'error', `Message is required`);
    } else {
      setIsLoading(true);

      setTimeout(() => {
        handleSnackbarVal(
          true,
          'success',
          `Your message has been send to the contact support team`
        );
      }, 2000);

      setTimeout(() => {
        setIsLoading(false);
        handleCloseSnackbar();
      }, 3000);
    }
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, '', '');
  };

  return (
    <>
      <AuthBackground heading={'Privacy Policy'} gridValue={8}>
        <SnackbarAlert
          snackbarProps={snackbarProps}
          handleCloseSnackbar={handleCloseSnackbar}
        />
        <div className={classes.paper}>
          <Typography style={{ fontSize: '25px', fontWeight: '600' }}>
            Privacy Policy for Travel App
          </Typography>
          <Typography style={{ fontSize: '14px', fontWeight: '400' }}>
            At NextTrip, we respect and protect the privacy of our users. This
            Privacy Policy outlines the type of information we collect and how
            we use, store, and share it. By using our Travel App, you consent to
            our collection, use, and sharing of your information as described in
            this Privacy Policy.
          </Typography>
          <Typography style={{ fontSize: '25px', fontWeight: '600' }}>
            Collection of Information
          </Typography>
          <Typography style={{ fontSize: '14px', fontWeight: '400' }}>
            We collect certain personal information from you when you use our
            Travel App. This information includes, but is not limited to, your
            name, email address, phone number, and location data. We may also
            collect information about your device and the way you use our Travel
            App, such as your IP address, browser type, and operating system.
          </Typography>
          <Typography style={{ fontSize: '25px', fontWeight: '600' }}>
            Use of Information
          </Typography>
          <Typography style={{ fontSize: '14px', fontWeight: '400' }}>
            We use the information we collect from you to provide you with a
            personalized and efficient experience when using our Travel App.
            This includes but is not limited to, providing travel
            recommendations, booking travel services, and communicating with you
            about your travel plans. We may also use your information to improve
            our services and to send you marketing communications.
          </Typography>
          <Typography style={{ fontSize: '25px', fontWeight: '600' }}>
            Sharing of Information
          </Typography>
          <Typography style={{ fontSize: '14px', fontWeight: '400' }}>
            We may share your personal information with third-party service
            providers who help us operate our Travel App and provide you with
            travel services. These third-party providers are contractually
            obligated to keep your information confidential and to only use it
            for the purposes of providing their services to us. We may also
            share your information with law enforcement agencies or other third
            parties if we are required to do so by law.
          </Typography>

          <Typography style={{ fontSize: '25px', fontWeight: '600' }}>
            Data Security
          </Typography>
          <Typography style={{ fontSize: '14px', fontWeight: '400' }}>
            We take the security of your information seriously and take measures
            to protect it from unauthorized access, disclosure, or use. We use
            industry-standard security measures, including encryption and secure
            socket layer (SSL) technology, to protect your information. However,
            no data transmission over the internet or electronic storage system
            is completely secure, and we cannot guarantee the absolute security
            of your information.
          </Typography>
          <Typography style={{ fontSize: '25px', fontWeight: '600' }}>
            Your Choices
          </Typography>
          <Typography style={{ fontSize: '14px', fontWeight: '400' }}>
            You have the right to access, update, and delete the personal
            information we have collected from you. You may also choose to
            opt-out of receiving marketing communications from us at any time.
          </Typography>

          <Typography style={{ fontSize: '25px', fontWeight: '600' }}>
            Changes to this Privacy Policy
          </Typography>

          <Typography style={{ fontSize: '14px', fontWeight: '400' }}>
            We may update this Privacy Policy from time to time, and we will
            notify you of any material changes by posting the updated Privacy
            Policy on our Travel App. We encourage you to review this Privacy
            Policy periodically.
          </Typography>
        </div>
      </AuthBackground>
    </>
  );
};

export default PrivacyPolicy;
